import { HStack, Icon, IconButton, Modal, Text, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box, Modal as NativeModal } from 'native-base';
import React from 'react';

import { RowActions } from '../../../MainReportGenerator/DocumentsTable/shared/row/RowActions';
import { StatusBadge } from '../../../MainReportGenerator/DocumentsTable/shared/row/StatusBadge';
import { useReportGeneratorItemActions } from '../../../MainReportGenerator/DocumentsTable/shared/row/useReportGeneratorItemActions';
import { RecentSameFileModalViewProps } from '../types';

export const RecentSameFileModalView: React.FC<RecentSameFileModalViewProps> = ({
  isOpen,
  onClose,
  report,
  showPeriodLabel,
  contentMaxHeight,
  contentMaxWidth,
  contentMarginBottom,
  contentMarginTop,
  getReportingFileAndDownload,
}) => {
  const { actionLoading, handleDownload } = useReportGeneratorItemActions({
    item: report,
    onDownload: async (item, onComplete) => {
      if (!item.isDownloadEnabled) {
        onComplete();
        return;
      }

      await getReportingFileAndDownload(item);
      onComplete();
    },
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} testId="report-generator-recent-same-file-details">
      <NativeModal.Content
        alignItems="center"
        w="full"
        maxH={contentMaxHeight}
        maxW={contentMaxWidth}
        marginBottom={contentMarginBottom}
        marginTop={contentMarginTop}
        borderRadius={BoxBorder.heavy}
        background="neutral.white">
        <VStack w="full" px="inline.xxs" py="inline.xs" space="stack.xxxs">
          <HStack justifyContent="space-between" flex={1} alignItems="center" space="inline.quarck">
            <VStack flex={1} space="stack.quarck">
              <HStack space="inline.nano" alignItems="center">
                <Icon name="Info" size="xxxs" color="brand.tertiary.principal" />
                <Text color="neutral.dark" variant="semibold">
                  Relatórios solicitados
                </Text>
              </HStack>

              <Text color="neutral.dark">
                Você já solicitou este relatório nas últimas 24 horas. Confira o status abaixo.
              </Text>
            </VStack>
            <IconButton
              testId="report-generator-recent-same-file-close"
              icon="CloseModal"
              iconSize="xs"
              borderWidth="1"
              variant="rounded"
              backgroundColor="transparent"
              iconColor="brand.primary.principal"
              borderColor="brand.primary.principal"
              onPress={onClose}
              p={0}
            />
          </HStack>

          <Box borderBottomWidth={1} borderColor="neutral.lightest" borderBottomStyle="dashed" />

          <VStack
            w="full"
            px="inline.xxs"
            py="stack.xxxs"
            space="stack.nano"
            borderRadius={BoxBorder.heavy}
            background="background">
            <HStack justifyContent="space-between" w="full">
              <Text variant="semibold">{report.documentType}</Text>
              <Text color="neutral.medium">
                {showPeriodLabel ? 'Período: ' : ''}
                {report.selectedPeriodDisplay}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="full" alignItems="center">
              <Text color="neutral.medium">Status</Text>
              <StatusBadge
                status={report.status}
                normalizedError={report.normalizedError}
                bgColor={report.statusIcon.bgColor}
                color={report.statusIcon.color}
              />
            </HStack>
            <HStack justifyContent="space-between" w="full" alignItems="center">
              <Text color="neutral.medium">Ação</Text>
              <RowActions item={report} actionLoading={actionLoading} onDownload={handleDownload} />
            </HStack>
          </VStack>
        </VStack>
      </NativeModal.Content>
    </Modal>
  );
};
